import { render, staticRenderFns } from "./debenturesOfInet.vue?vue&type=template&id=f98c2b4e&scoped=true"
import script from "./debenturesOfInet.vue?vue&type=script&lang=js"
export * from "./debenturesOfInet.vue?vue&type=script&lang=js"
import style0 from "./debenturesOfInet.vue?vue&type=style&index=0&id=f98c2b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98c2b4e",
  null
  
)

export default component.exports